<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <invoices-overview/>
    </v-card>
  </app-layout>
</template>
<script>
import InvoicesOverview from '@/components/routes/invoices/InvoicesOverview'
export default {
  name: 'Invoices',
  components: { InvoicesOverview },
  i18n: {
    messages: {
      en: {
        heading: 'Invoices overview'
      },
      de: {
        heading: 'Übersicht Rechnungen'
      },
      ru: {
        heading: 'Обозор инвойсов'
      },
      tr: {
        heading: 'Genel bakış faturaları'
      }
    }
  }
}
</script>
